export const previousOwnersTypes = [
  { label: '1', value: 'ONE' },
  { label: '2', value: 'TWO' },
  { label: '2+', value: 'TWO_PLUS' },
];
